import { AdminLayout } from "@/components/layouts/admin-layout"
import { usePage } from "@inertiajs/react"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { MainContainer } from "@/components/ui/container"
import { ProfileSidebar } from "@/components/features/profiles/profile-sidebar"

type SharedUser = {
  name: string
  email: string
  initials: string
  avatar: string | null
}

export default function AdminProfilesShow() {
  const { user } = usePage<{ user: SharedUser | null }>().props

  if (!user) return null

  return (
    <AdminLayout>
      <MainContainer size="xs">
        <div className="flex flex-col items-center gap-3 my-15 text-center">
          <Avatar className="size-16">
            <AvatarImage src={user.avatar || ""} alt={user.name} />
            <AvatarFallback className="text-lg">
              {user.initials}
            </AvatarFallback>
          </Avatar>
          <div>
            <h1 className="text-xl font-bold">{user.name}</h1>
            <p className="text-sm text-muted-foreground">{user.email}</p>
          </div>
        </div>

        <ProfileSidebar />
      </MainContainer>
    </AdminLayout>
  )
}
